import { getPerformance, trace } from '@firebase/performance'
import { useFlag } from '@unleash/proxy-client-react'
import { getApp } from 'firebase/app'

export default function useFirebaseTracing(traceName: string) {
  const perf = getPerformance(getApp())
  const t = trace(perf, traceName)

  const { performance } = window
  const isFirebaseTracingEnabled = useFlag('isFirebaseTracingEnabled')

  const mark = (markName: string, detail?: any) => {
    if (isFirebaseTracingEnabled) {
      performance.mark(markName, { detail })
    }
  }

  const startTracing = () => {
    if (isFirebaseTracingEnabled) {
      t.start()
    }
  }

  const stopTracing = () => {
    if (isFirebaseTracingEnabled) {
      t.stop()
    }
  }
  return { mark, startTracing, stopTracing }
}
